import React from 'react';
import PropTypes from 'prop-types';
import {Box} from '@mui/material';

// AD-2691: the components on one row of a form, side by side, each at its own width. On a phone they go one
// under another. A row of one component is shown exactly as before.
const FormRow = ({widths, children, gap = 2}) => {
    const items = React.Children.toArray(children);
    if (items.length < 2) return <>{items}</>;

    return (
        <Box sx={{display: 'flex', flexDirection: {xs: 'column', sm: 'row'}, columnGap: gap, alignItems: 'stretch'}}>
            {items.map((item, position) => (
                <Box
                    key={item.key ?? position}
                    sx={{
                        flex: {xs: '1 1 auto', sm: `${widths[position] ?? 1} 1 0`},
                        minWidth: 0,
                        display: 'flex',
                        flexDirection: 'column',
                        '& > *': {flexGrow: 1},
                    }}
                >
                    {item}
                </Box>
            ))}
        </Box>
    );
};

FormRow.propTypes = {
    widths: PropTypes.arrayOf(PropTypes.number).isRequired,
    children: PropTypes.node,
    gap: PropTypes.number,
};

export default FormRow;
